/**
 * 签收方式(S-55,决策 Y-44 / Y-47)。**单点定义在这里,三端引用**,
 * 与契约 components.schemas.SignatureVia 的 enum 逐字一致,顺序也一致。
 *
 * ═══ 为什么「方式」必须和「时间」分开记 ═══
 *
 * 签收是订单上的**旁挂事实**(Y-44),不是状态机上的新一档。而「谁签的」与
 * 「怎么签的」是两件事(Y-47 原文):只有时间没有方式的话,事后分不清这一单是
 * 收件人自己点的、系统到点代签的、还是运营替收件人确认的 —— 而这三者在纠纷里的
 * 分量完全不同。一条「已签收」而说不清怎么签的记录,等于没有签收。
 *
 *   user  收件人自己点确认(手机号与订单收件人手机号一致的那个账号,Y-45)
 *   auto  送达 N 天后仍未签收,到点自动签收(N 是平台配置项,Y-47,惰性判定)
 *   ops   运营端人工代确认(收件人不注册 / 手机号填错时的兜底,Y-47)
 *
 * ═══ 它与「签收账号」是两个字段 ═══
 *
 * signedByUserId 记的是**签收的那个账号**(auto 时为空 —— 没有账号点的);
 * signedVia 记的是**怎么签的**。两者都在 Order 上,都在契约的 OrderDetail 里。
 *
 * prisma/schema.prisma 里有一份同名的数据库枚举(数据库需要自己的类型定义),
 * 两处的一致性由 apps/api/src/common/enum-parity.ts 的类型级断言盯着 ——
 * 对不上时 `pnpm typecheck` 直接失败。中文表就住在**这个文件里**
 * (与凭证节点 PROOF_NODE_LABEL 同一做法:服务端错误话术与两个后台端都要用),
 * 由 guards/check-enum-labels.mjs 与取值集合逐一对上。
 */
export const SIGNATURE_VIA = ['user', 'auto', 'ops'] as const

export type SignatureVia = (typeof SIGNATURE_VIA)[number]

export function isSignatureVia(x: unknown): x is SignatureVia {
  return typeof x === 'string' && (SIGNATURE_VIA as readonly string[]).includes(x)
}

/** 给人看的中文名。纠纷里要能读出来是「谁签的」—— 页面上不该出现 user / auto / ops */
export const SIGNATURE_VIA_LABELS: Record<SignatureVia, string> = {
  user: '收件人确认',
  auto: '到点自动',
  ops: '运营代确认',
}

/** 认不出来的取值原样返回(与其它标签函数同一形状:不猜一个档位) */
export function signatureViaLabel(value: SignatureVia | string): string {
  return SIGNATURE_VIA_LABELS[value as SignatureVia] ?? String(value)
}
